import { fromTemplate } from '../../utils/dom.js';
import './about.css';

export class About {
  render() {
    const template = `
      <section class="sl-about" id="about" data-testid="about">
        <div class="container sl-about__grid">
          <div>
            <h2 class="sl-about__title">About Striking Labs</h2>
            <p class="sl-about__body">
              Striking Labs is a small software studio. We partner with founders
              and product teams to ship capable, well-considered software across
              the web and Apple platforms.
            </p>
            <p class="sl-about__body">
              Our team has over 23 years of experience in enterprise and cloud software, 
              consumer apps and services, and everything in between. We care deeply about craftsmanship,
                and we bring that to every project we work on.
            </p>
          </div>
          <ul class="sl-about__facts">
            <li><span>Based</span><strong>United States</strong></li>
            <li><span>Founded</span><strong>2015</strong></li>
            <li><span>Focus</span><strong>Web &middot; iOS &middot; macOS</strong></li>
          </ul>
        </div>
      </section>
    `;
    return fromTemplate(template);
  }
}
